import {useGetApplications} from "../application/useGetApplications";

export const useEkulturAdminUrl = () => {
    const adminAppId = '0f99554d-4d53-4ce6-ada5-6189f3abdf52'
     const apps = useGetApplications()
    return apps ? apps[adminAppId].url : ""
}